var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.getClassObject(),on:{"click":_vm.handleClick}},[_c('use',{attrs:{"xlink:href":`#V_Vlt-icon-${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }